import { ManagementBackendClient } from "@lib/apis";

export default {
  ManagementBackend: new ManagementBackendClient(
    import.meta.env.VITE_MANAGEMENT_URL,
  ),
};
